// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconLock.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconLock = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="m13.442,7.29624l-0.4368,0l0,-2.07312c0,-2.88002 -2.24534,-5.22312 -5.0052,-5.22312c-2.75986,0 -5.00518,2.34309 -5.00518,5.22312l0,2.07312l-0.43683,0c-0.58431,0 -1.05799,0.4943 -1.05799,1.10405l0,6.49561c0,0.6098 0.47368,1.1041 1.05799,1.1041l10.88401,0c0.5843,0 1.058,-0.4943 1.058,-1.1041l0,-6.49561c0,-0.60975 -0.4737,-1.10405 -1.058,-1.10405zm-2.55279,0l-5.77842,0l0,-2.07312c0,-1.66255 1.29614,-3.01501 2.88921,-3.01501c1.59307,0 2.88921,1.35246 2.88921,3.01501l0,2.07312z" />
  </BaseIcon>
);

export default IconLock;
